import React, {useState} from 'react'
import {
  Box, useColorMode, useToast, Text, Tooltip,
  HStack, Center,
  Heading, useDisclosure, ModalBody,
} from "@chakra-ui/react";
import { useGateways } from '../../contexts/gateways';
import DataTable, { SearchBar, getUniformedColumns } from "@/shared/components/DataTable";
import { useHistory } from "react-router-dom";
import { InfoIcon, TriangleIcon, CircleIcon } from "../../shared/icons";
import { useIsMobile, useIsTablet } from "../../hooks";
import { useTranslation } from "react-i18next";
import { useAuth } from '../../contexts/auth'
import ModalSkeleton from "@/shared/components/ModalSkeleton";
import { formatterDate } from '../../utils/formatters';


const Gateways = (props) => {
  const { colorMode } = useColorMode();
  const toast = useToast()
  const isMobile = useIsMobile()
  const isTablet = useIsTablet()
  const history = useHistory()
  const { t } = useTranslation(['general', 'minds'])
  const { isOpen, onOpen, onClose } = useDisclosure()
  // TODO: for the moment return all gateways, but we should filter only the ones related to the user. so not use currentUserGateways but gateways and filter them here, or filter them in the backend
  const { gateways, currentUserGateways, isFetching } = useGateways()
  const [selectedGateway, setSelectedGateway] = useState()

  const columnsProps = {
    serial: {
      text: t('general:serial', 'Serial').toCapitalCase(),
      sort: true,
      formatter: (cell, row) => (<Tooltip placement='auto-start' label={cell === null ? 'device serial': 'serial'}>{cell === null ? row.device_serial : cell}</Tooltip>)
    },
    sw_version: {
      text: t('general:SwVersion', 'Sw Version'),
      sort: true,
    },
    // TODO: verificare se funziona e aggiungere anche altre informazioni come la versione del sw
    last_seen: {
      text: t('general:LastSeen', 'Last Seen'),
      sort: true,
      formatter: (cell, row) => {
        if (!cell) return '-'
        const lastSeen = new Date(cell)
        if (Number.isNaN(lastSeen.getTime())) return cell

        const isOnline = (new Date() - lastSeen) <= 5 * 60 * 1000
        const color = isOnline ? `frigel.${colorMode}.status.online` : "frigel.neutral.gray3"

        return (
          <Tooltip label={formatterDate(cell)}>
            <HStack justifyContent='center'>
            <CircleIcon fontSize="xl" color={color} />
            {row['is_clock_skew_high'] &&
              <TriangleIcon fontSize="lg" color={`frigel.${colorMode}.status.warning`}/>}
            </HStack>
          </Tooltip>
        )
      },
    },
    info: {
      isDummyField: true,
      text: t('general:info', 'info').toCapitalCase(),
      formatter: (cell, row) => (
        <InfoIcon
          cursor='pointer'
          fontSize={{ base: "xs", md: "md" }}
          onClick={() => {
            setSelectedGateway(row);
            onOpen();
          }}
        />
        // TODO: we should have a specific info page for the gateway, but for now we can use the same modal we use for the machines, but we need to fetch the data from the backend and pass it to the modal. so we need to create a new endpoint in the backend that returns the gateway info based on the serial and mind_id, and then we can use that data to display the info in the modal. for now we can just display the serial and mind_id in the modal, but in the future we can add more info like the last seen, first added, etc.
        // <OpenWindowIcon
        //     cursor="pointer"
        //     fontSize={{ base: "xs", md: "md" }}
        //     onClick={() => history.push(`/gateways/${row.serial}`)}
        // />
      )
    },
  };
  const columns = getUniformedColumns(Object.keys(columnsProps), columnsProps);

  return (
    <>
      <Box flex="1" textAlign="left" my={12}>
        <DataTable
          data={gateways}
          columns={columns}
          noDataIndication={<Center>{t('general:NoData', "No data to display")}</Center>}
          customSizePerPage={15}
          toolbar={(props) => <Box width={{ base: '100%', md: '80%' }}>
            <HStack>
              <Box width="30%">
                <SearchBar searchProps={props.searchProps} />
              </Box>
            </HStack>
          </Box >}
        />
      </Box >
      <ModalSkeleton isOpen={isOpen} onClose={onClose} size='xl' title={
        <HStack spacing={2}>
          <InfoIcon fontSize='md' />
          <Heading fontSize='md' as='h3'>
            {t('general:gatewayInfo', 'Gateway Info')}
          </Heading>
        </HStack>
      }>
        <ModalBody>
          <Text><b>{t('general:deviceSerial', 'Device Serial')}:</b> {selectedGateway?.device_serial}</Text>
          <Text><b>{t('general:serial', 'Serial').toCapitalCase()}:</b> {selectedGateway?.serial}</Text>
          <Text><b>{t('general:FirstAdded', 'First Added').toCapitalCase()}:</b> {formatterDate(selectedGateway?.first_added)}</Text>
          <Text><b>{t('general:LastSeen', 'Last Seen').toCapitalCase()}:</b> {formatterDate(selectedGateway?.last_seen)}</Text>
          <Text><b>{t('general:ipMind', 'Mind IP')}:</b> {selectedGateway?.mind_ip}</Text>
          <Text><b>{t('general:deviceConfiguration', 'Device Configuration')}:</b> {selectedGateway?.device_configuration}</Text>
          <Text><b>{t('general:OperatingSystem', 'Operating System')}:</b> {`${selectedGateway?.operating_system} ${selectedGateway?.os_version}`}</Text>
          <Text><b>{t('general:SwVersion', 'Sw Version')}:</b> {selectedGateway?.sw_version}</Text>
          <Text><b>{t('general:machines', 'Machines').toCapitalCase()}:</b></Text>
          {selectedGateway?.machines?.length > 0 ? (
            selectedGateway.machines.map((machine, index) => (
              <Box key={index} pl={4}>
                <Text>- {machine.name || machine.serial || `Machine ${index + 1}`}</Text>
              </Box>
            ))
          ) : (
            <Box pl={4}>
              <Text>- {t('general:NoData', "No machines")}</Text>
            </Box>
          )}

        </ModalBody>
      </ModalSkeleton>
    </>
  )
}
export default Gateways;